export const slidesInfo = [
  {
    alt: "Laberinto",
    title: "Laberinto",
    url: "https://github.com/alonsodiaxz/Laberinto",
    desc: "Aplicación que dibuja un laberinto con la dimensión elegida por el usuario y encuentra el camino más corto entre dos puntos del mismo.  ",
    date: "Java | Octubre 2020",
    app: "Aplicación escritorio",
    par: "Cristina Carretero",
    asig: "Sistemas Inteligentes",
    web: false,
    desp: "",
  },
  {
    alt: "Web Peliculas",
    title: "Web Peliculas",
    urlc: "https://github.com/alonsodiaxz/Cliente-Multimedia",
    urls: "https://github.com/alonsodiaxz/Server-Multimedia",
    desc: "Aplicación  parecida a Netflix en la que podemos ver una gran variedad de películas filtrándolas por género, nombre y populares; ver sus trailers y valorarlas con estrellas y comentarios.",
    date: "React | Octubre 2021",
    app: "Aplicación Web",
    par: "Juan Manuel Porrero Almansa",
    asig: "Multimedia",
    web: true,
    desp: "https://web-app-peliculas.netlify.app",
  },
  {
    alt: "SocketIo Chat",
    title: "SocketIo Chat",
    urlc: "https://github.com/alonsodiaxz/FrontEndSocket.io-Chat",
    urls: "https://github.com/alonsodiaxz/Back-End-Socket.io-Chat",
    desc: "Proyecto de un curso de Udemy que consiste en un chat parecido a WhatsApp, que permite la comunciación entre dos personas en tiempo real.  ",
    date: "React | Marzo 2021",
    app: "Aplicación Web",
    par: "Individual",
    asig: "Enseñanzas propias",
    web: true,
    desp: "https://chatsocketio.netlify.app",
  },
  {
    alt: "TwitterClone",
    title: "TwitterClone",
    urlc: "https://github.com/alonsodiaxz/Front-EndTwitter",
    urls: "https://github.com/alonsodiaxz/TwitterApp",
    desc: "Proyecto del curso de enseñanzas propias realizado por la escuela, que simula el funcionamiento de twitter, pudiendo crear, leer, editar y borrar tweets.",
    date: "React | Marzo 2021",
    app: "Aplicación Web",
    par: "Individual",
    asig: "Enseñanzas propias",
    web: true,
    desp: "https://alonsodiaxz.github.io/Front-EndTwitter/",
  },
  {
    alt: "tamagotchi",
    title: "Tamagotchi",
    url: "https://github.com/alonsodiaxz/Tamagotchi",
    desc: "Aplicación de escritorio que simula el comportamiento de los famosos tamagotchis con los que todos hemos jugado de niños, pudiendo interactuar con él.",
    date: "C# | Abril 2021",
    app: "Aplicación Escritorio",
    par: "Individual",
    asig: "Interacción Persona-Ordenador II",
    web: false,
    desp: "",
  },
  {
    alt: "trenes",
    title: "Gestión de Trenes",
    url: "https://github.com/alonsodiaxz/GestionTrenes",
    desc: "Proyecto que maneja la gestión de una serie de trenes de mercancías almacenados en una base de datos mediante una interfaz gráfica.",
    date: "Visual Basic .NET | Abril 2020",
    app: "Aplicación Escritorio",
    par: "Desiderio Almansa Porrero",
    asig: "Bases de Datos",
    web: false,
    desp: "",
  },
  {
    alt: "bus",
    title: "Autobús",
    url: "https://github.com/alonsodiaxz/Bus",
    desc: "Proyecto que simula la gestión de reservas de los asientos de un autobús, mediante el uso de matrices.  ",
    date: "Java | Diciembre 2018",
    app: "Aplicación Escritorio",
    par: "Individual",
    asig: "Fundamentos de Programación I",
    web: false,
    desp: "",
  },
  {
    alt: "chatapp",
    title: "ChatAppNextJS",
    url: "https://github.com/alonsodiaxz/NextJs-chat-app",
    desc: "Aplicación realizada en Next JS que permite conversar con otros usuarios utilizando Chat Engine una API Rest que nos proporciona servicio de chat .",
    date: "Next JS | Noviembre 2021",
    app: "Aplicación web",
    par: "Individual",
    asig: "Enseñanzas propias",
    web: false,
    desp: "",
  },
  {
    alt: "ReservasCamping",
    title: "Reservas Camping",
    url: "https://github.com/CrisCarretero/Practicas-IPO",
    desc: "Aplicación desarrollada en Java para gestionar las reservas de un camping además de las distinas actividades que en él se llevan acabo.",
    date: "Java | Diciembre 2020",
    app: "Aplicación escritorio",
    par: "Cristina Carretero",
    asig: "Interacción Persona-Ordenador I",
    web: false,
    desp: "",
  },
  {
    alt: "WebPersonal",
    title: "Web Personal",
    url: "https://github.com/alonsodiaxz/PersonalPortfolio",
    desc: "Portfolio personal en el que muestro un poquito más acerca de mí.",
    date: "React JS | Octubre 2021",
    app: "Página Web",
    par: "Individual",
    asig: "Web Personal",
    web: false,
    desp: "",
  },
];
